<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [style]="{ width: '34rem' }"
  [header]="isEdit() ? ('GlAccountRule_Edit' | translateWF: 'Edit rule') : ('GlAccountRule_New' | translateWF: 'New rule')"
  (onHide)="onHide()"
>
  <form [formGroup]="form" class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <label for="rule-scope">{{ fieldLabels.scope | translateWF: 'Scope' }}</label>
      <p-selectbutton inputId="rule-scope" formControlName="scope" [options]="scopeOptions()" optionLabel="label" optionValue="value" [allowEmpty]="false" />
    </div>

    <div class="flex flex-col gap-2">
      <label for="rule-role">{{ fieldLabels.role | translateWF: 'Role' }}</label>
      <p-selectbutton inputId="rule-role" formControlName="role" [options]="roleOptions()" optionLabel="label" optionValue="value" [allowEmpty]="false" />
    </div>

    @if (scope() === Scope.ExpenseClaim) {
      <div class="flex flex-col gap-2">
        <label for="rule-concept">{{ fieldLabels.conceptCode | translateWF: 'Concept' }} <span class="text-red-500">*</span></label>
        <p-select
          inputId="rule-concept"
          formControlName="conceptCode"
          [options]="conceptOptions"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [placeholder]="'GlAccountRule_Pick_Concept' | translateWF: 'Choose a concept…'"
          appendTo="body"
          styleClass="w-full"
        />
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        <label for="rule-inventory-type">{{ fieldLabels.inventoryTypeReference | translateWF: 'Inventory type' }} <span class="text-red-500">*</span></label>
        <p-select
          inputId="rule-inventory-type"
          formControlName="inventoryTypeReference"
          [options]="inventoryTypeOptions"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [placeholder]="'GlAccountRule_Pick_InventoryType' | translateWF: 'Choose an inventory type…'"
          appendTo="body"
          styleClass="w-full"
        />
      </div>
    }

    <div class="flex flex-col gap-2">
      <label for="rule-cost-center">{{ fieldLabels.costCenterCode | translateWF: 'Cost center' }}</label>
      <p-select
        inputId="rule-cost-center"
        formControlName="costCenterCode"
        [options]="costCenterOptions"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        appendTo="body"
        styleClass="w-full"
      />
      <small class="text-[var(--p-text-muted-color)]">
        {{ 'GlAccountRule_CostCenter_Hint' | translateWF: 'Empty = any cost center. A parent node is inherited by all its children.' }}
      </small>
    </div>

    <app-financial-account-select
      [referenceControl]="form.controls.glAccountReference"
      [financialCompanyReference]="financialCompanyReference"
      [label]="fieldLabels.glAccountReference | translateWF: 'GL account'"
      [placeholder]="'GlAccountRule_Pick_Account' | translateWF: 'Choose an account…'"
      [required]="true"
      [readonly]="!canEdit"
    />

    <p-card styleClass="rule-preview">
      <div class="flex flex-col gap-3">
        <span class="rule-preview__title">{{ 'GlAccountRule_Preview_Title' | translateWF: 'Resolution preview' }}</span>
        @if (previewState(); as state) {
          @if (state.loading && !state.preview) {
            <p-progressbar mode="indeterminate" [style]="{ height: '4px' }" />
          }
          @if (state.preview; as preview) {
            @if (preview.conflict) {
              <p-message severity="error" [text]="conflictText(preview)" />
            } @else {
              <p>
                <strong class="tabular-nums">{{ preview.costCenterCodes.length }}</strong>
                {{ 'GlAccountRule_Preview_Of' | translateWF: 'of' }} {{ preview.totalCostCenters }}
                {{ 'GlAccountRule_Preview_WillTake' | translateWF: 'cost centers will take this account.' }}
              </p>
              @if (preview.costCenterCodes.length > 0) {
                <div class="flex flex-wrap gap-2">
                  @for (name of winningNames(preview); track $index) {
                    <p-tag severity="secondary" [value]="name" />
                  }
                </div>
              } @else {
                <p class="text-sm">
                  {{ 'GlAccountRule_Preview_NoWins' | translateWF: 'No line will use it: a more specific rule already wins in every cost center it reaches.' }}
                </p>
              }
              @if (preview.replaces.length > 0) {
                <div class="flex flex-col gap-1">
                  <span class="font-medium">{{ 'GlAccountRule_Preview_Replaces' | translateWF: 'Replaces' }}</span>
                  @for (line of replacementText(preview); track $index) {
                    <span class="text-sm">{{ line }}</span>
                  }
                </div>
              }
            }
          } @else if (!state.loading) {
            <p class="text-sm text-[var(--p-text-muted-color)]">
              {{ 'GlAccountRule_Preview_Incomplete' | translateWF: 'Complete the rule to see where it applies.' }}
            </p>
          }
        }
      </div>
    </p-card>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-between gap-2">
      <div>
        @if (isEdit() && canEdit) {
          <p-button [label]="'GlAccountRule_Deactivate' | translateWF: 'Deactivate'" severity="danger" [text]="true" [disabled]="isSaving()" (onClick)="onDeactivate()" />
        }
      </div>
      <div class="flex gap-2">
        <p-button [label]="'Cancel' | translateWF: 'Cancel'" severity="secondary" [outlined]="true" (onClick)="visible = false" />
        @if (canEdit) {
          <p-button [label]="'Save' | translateWF: 'Save'" [loading]="isSaving()" [disabled]="!!previewState().preview?.conflict" (onClick)="onSave()" />
        }
      </div>
    </div>
  </ng-template>
</p-drawer>
